import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface ObtenerPqrsRequest {
  codigo?: string;
  "unidad residencial codigo": string;
  "apartamento codigo"?: string;
  "tipo codigo"?: string;
  "estatus codigo"?: string;
  "fecha inicial"?: string;
  "fecha final"?: string;
}

export interface PqrRecord {
  pqr_codigo: number | string;
  pqr_apartamento: string;
  pqr_apartamento_nombre: string;
  pqr_tipo: string;
  pqr_tipo_nombre: string;
  pqr_asunto: string;
  pqr_descripcion: string;
  pqr_fecha_creacion: string;
  pqr_estatus: string;
  pqr_estatus_nombre: string;
  pqr_respuesta: string;
  pqr_fecha_cierre: string;
  pqr_ruta_foto?: string;
}

export interface ResponderPqrRequest {
  codigo: string;
  respuesta: string;
}

export interface CerrarPqrRequest {
  codigo: string;
}

export const obtenerPqrs = async (payload: ObtenerPqrsRequest) => {
  const envelope = await myFetch<ApiEnvelope<PqrRecord[]>>(
    "pqr/ObtenerTodos",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const responderPqr = async (payload: ResponderPqrRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "pqr/Responder",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const cerrarPqr = async (payload: CerrarPqrRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "pqr/Cerrar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

